import * as React from 'react'
import cn from 'classnames'
import { CareermindsLogo } from 'components/atoms/careerminds-logo'

export type PoweredByBrandProps = {
  className?: string
}

/**
 * The attribution badge on public framework pages.
 *
 * Careerminds has no drawn badge asset, so it is composed from a label and the
 * wordmark — mirroring Ruby's BrandingHelper#brand_powered_by_tag, which draws
 * the same thing for the ERB footer. Styles for both halves live in
 * `.cm-poweredby` (stylesheets/base/_careerminds-brand.scss) so the two stay in
 * step.
 */
export const PoweredByBrand: React.VFC<PoweredByBrandProps> = ({
  className,
}) => (
  <span className={cn('cm-poweredby', className)}>
    <span className="cm-poweredby__label">Powered by</span>
    <CareermindsLogo className="cm-poweredby__logo" />
  </span>
)
